// Cookies musí přežít zavření prohlížeče. BE drží REFRESH_TOKEN persistentně (30 dní na produkci),
// ale bez `token` a `x-client`, které k němu FE posílá, ho nelze použít – refresh vrátí
// API_TOKEN_MISSING a session se ztratí. Bez Max-Age byly tyhle cookies session cookies.
const DEFAULT_MAX_AGE_SECONDS = 60 * 60 * 24 * 30

// Trojice, která dohromady identifikuje API session. Primárně v cookie (sdílená přes *.cinestar.cz
// s hlavním webem), zrcadlená do localStorage jako záloha, když cookie zmizí.
export const SESSION_KEYS = ['token', 'token_validity', 'x-client']

const isUnderDomain = (hostname, domain) => hostname === domain || hostname.endsWith(`.${domain}`)

const isUsable = (value) => Boolean(value) && value !== 'undefined'

export function getCookie(cookieName) {
    const cookieString = document.cookie
    const cookies = cookieString.split('; ')

    for (const cookieItem of cookies) {
        const eqIndex = cookieItem.indexOf('=')
        if (eqIndex === -1) continue
        let name, value
        try {
            name = decodeURIComponent(cookieItem.slice(0, eqIndex).trim())
            const valuePart = cookieItem.slice(eqIndex + 1).trim()
            value = valuePart ? decodeURIComponent(valuePart) : ''
        } catch {
            continue
        }

        if (name === cookieName) {
            return value
        }
    }

    return ''
}

export function setCookie(cookieName, cookieValue, maxAgeSeconds = DEFAULT_MAX_AGE_SECONDS) {
    //SETS TO cinestar.cz to share cookie between subdomains in production
    const mainDomain = process.env.REACT_APP_BASE_WEBSALE_TOP_DOMAIN
    if (!mainDomain) {
        console.error('no base url')
    }

    let cookieString = `${encodeURIComponent(cookieName)}=${encodeURIComponent(cookieValue)}; path=/`

    // domain prohlížeč přijme jen když pod ni aktuální host patří, jinak cookie zahodí celou
    if (mainDomain && isUnderDomain(location.hostname, mainDomain)) {
        cookieString += `; domain=${mainDomain}`
    }

    // setCookie(name, '') se v aplikaci používá jako "smaž" – Max-Age=0 ji musí opravdu odstranit
    cookieString += cookieValue === '' ? '; Max-Age=0' : `; Max-Age=${maxAgeSeconds}`

    cookieString += '; SameSite=Lax'
    if (location.protocol === 'https:') {
        cookieString += '; Secure'
    }

    document.cookie = cookieString
}

// Cookie je primární zdroj, localStorage záloha pro případ, že cookie zmizela.
export function getPersisted(key) {
    const fromCookie = getCookie(key)
    if (isUsable(fromCookie)) {
        return fromCookie
    }

    const fromStorage = localStorage.getItem(key)

    return isUsable(fromStorage) ? fromStorage : ''
}

export function setPersisted(key, value) {
    setCookie(key, value)
    localStorage.setItem(key, value)
}

// Cookie mohla zmizet (starší build ji ukládal jako session cookie, čištění prohlížečem),
// zatímco kopie v localStorage přežila – vrátit ji, aby ji requesty zase posílaly.
export function restoreSessionCookies() {
    for (const key of SESSION_KEYS) {
        if (getCookie(key)) continue

        const stored = localStorage.getItem(key)
        if (isUsable(stored)) {
            setCookie(key, stored)
        }
    }
}

export function clearSession() {
    for (const key of SESSION_KEYS) {
        setCookie(key, '')
        localStorage.removeItem(key)
    }
}
